import { Component, OnInit } from '@angular/core';
import { ValueTypeService } from '@app/services/valueType/valuetype.service';

@Component({
  selector: 'app-outlets',
  templateUrl: './outlets.component.html',
  styleUrls: ['../pre-login.component.scss']
})
export class OutletsComponent implements OnInit {

  Stations: any[] = []; // ✅ initialize as array

  constructor(private valuetypesService: ValueTypeService) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.getstations();
  }

  getstations() {
    debugger;
    this.valuetypesService.getstations().subscribe({
      next: (response: any) => {
        console.log('✅ Raw station API response:', response);

        // sometimes API wraps the data in another object like { data: [...] }
        if (response && Array.isArray(response)) {
          this.Stations = response;
        } else if (response && response.data) {
          this.Stations = response.data;
        } else {
          this.Stations = [];
          console.warn('⚠️ Unexpected API format, no data array found.');
        }

        console.log('✅ Stations assigned:', this.Stations);
      },
      // error: (err) => {
      //   console.error('❌ Error fetching stations:', err);
      //   this.Stations = [];
      // }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/outlets/outlets.component.ts